// extracted by mini-css-extract-plugin
export default {"price":"Z6-z","onSale":"_6-z","msrpLabelPrice":"a7-z","msrpLabel":"b7-z","originalPrice":"c7-z","percentOff":"d7-z"};